import React from 'react'
import { QueryImage } from "../hooks/galdermaImgs.js"
import Img from 'gatsby-image'
import { Carousel } from 'react-bootstrap'
import { useState } from 'react'

const GaldermaImgs = () => {
    const allFile = QueryImage()
    const [indexA, setIndexA] = useState(0)
    const last = allFile.edges.length - 1

    const handleSelectA = (selectedIndex, e) => {
        setIndexA(selectedIndex)
    }

    return (
        <div>
             <Img
                fluid={allFile.edges[0].node.childImageSharp.fluid}
                className="my-3"
                alt="Photo"
            />
            <div id="carousel" className="my-3">
                <Carousel className="list" interval={null} activeIndex={indexA} onSelect={handleSelectA} indicators={false}>
                    {
                        allFile.edges.map((el, i) => (
                            i !== last && i !== 0 &&
                            <Carousel.Item key={i}>
                                <Img
                                    key={i}
                                    fluid={el.node.childImageSharp.fluid}
                                    alt="Photo"
                                />
                            </Carousel.Item>
                        ))
                    }
                </Carousel>
            </div>
            <Img
                fluid={allFile.edges[last].node.childImageSharp.fluid}
                alt="Photo"
            />
        </div>
    )
}

export default GaldermaImgs